import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useCallback, useMemo } from 'react';
import { getFrequency, getReportConfig } from 'reporting-data/report/configReportGetters';
import { isConfigReport, isMultiConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { getFrequencyOptions } from '../utils';
import { setFrequency } from 'reporting-data/report/configReportSetters';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigReportFrequencyDropdown = props => {
  const {
    report,
    onChange
  } = props;

  /***
   * note: am running isConfigReport(report) but this check will pass for multi-config reports
   * as well. Just doing this to get past TS checks because multi-configs are poorly typed.
   *  */
  const frequency = isConfigReport(report) && getFrequency(getReportConfig(report));
  const frequencyDropdownOptions = useMemo(() => isConfigReport(report) ? getFrequencyOptions(report) : [], [report]);
  const onFrequencyChange = useCallback(event => {
    const newFrequency = event.target.value;
    let updatedReport = report.setIn(['config', 'frequency'], newFrequency);
    if (isMultiConfigReport(updatedReport)) {
      updatedReport = updatedReport.update('reportConfigs', configs => {
        return configs.map(config => {
          return setFrequency(config, newFrequency);
        });
      });
    }
    onChange(updatedReport);
  }, [onChange, report]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.frequency-dropdown.config.label"
    }),
    children: /*#__PURE__*/_jsx(Select, Object.assign({}, props, {
      options: frequencyDropdownOptions,
      value: frequency,
      onChange: onFrequencyChange
    }))
  });
};
export default ConfigReportFrequencyDropdown;